module.exports = __webpack_public_path__ + "static/media/logo_short__white.e244d2fd.svg";